import React from 'react';

export default function EmailRetention() {
    return <div>EmailRetention</div>;
}
